import PropTypes from 'prop-types'

import {
  Box, Button, Form, SidebarModal, SidebarNoticeBox,
} from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useUser'

import EntitySelector from '@components/EntitySelector'
import useFindAgent from './hooks/useFindAgent'

const FindAgentModal = (props) => {
  const { callbacks, modalKey, showModal } = props

  const {
    agent,
    agent: { user },
    agentFormPayload,
    callbacks: {
      findAgent,
      editUser,
    },
    hasResult,
    searching,
    searchComplete,
  } = useFindAgent()

  const { email: agentEmail, full_name } = agent

  const {
    entityState,
    entityState: {
      agency_id,
      email,
      mobile,
      name,
    },
    errors,
    handlers,
    saveEnabled,
    setEntityState,
  } = agentFormPayload

  const { editUserUrl } = generateUrls(user)

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Find" titleSecondLine="Agent" />

      <SidebarModal.Content>
        <Box flexDirection="column" flexShrink={0}>

          <Form>
            <EntitySelector
              boxProps={{ marginTop: ['large', 0] }}
              callbacks={{
                selectItem: agency => setEntityState({ agency_id: agency ? agency.id : null }),
              }}
              entityKey="agencies"
              errorMessage={errors.agency_id}
              label="* Agency"
              selectedItemId={agency_id}
            />

            <Form.Field errorMessage={errors.title} label="Name" marginTop="large">
              <input name="name" value={name} type="text" {...handlers} />
            </Form.Field>

            <Form.Field errorMessage={errors.email} label="* Email" marginTop="large">
              <input
                data-validate-field-on="blur"
                name="email"
                value={email}
                type="text"
                {...handlers}
              />
            </Form.Field>

            <Form.Field errorMessage={errors.mobile} label="* Mobile" marginTop="large">
              <input
                name="mobile"
                value={mobile}
                type="email"
                {...handlers}
              />
            </Form.Field>

            {searchComplete && !hasResult && (
              <SidebarNoticeBox boxProps={{ marginTop: 'large' }}>
                <SidebarNoticeBox.Title>
                  Unsuccessful. No matching users found.
                </SidebarNoticeBox.Title>
                <SidebarNoticeBox.Paragraph>
                  There&apos;s no user matching the details provided.
                  &nbsp;Try changing the details to return a different result.
                </SidebarNoticeBox.Paragraph>
              </SidebarNoticeBox>
            )}

            {searchComplete && hasResult && (
              <SidebarNoticeBox boxProps={{ marginTop: 'large' }}>
                <SidebarNoticeBox.Title>
                  Success! User found.
                </SidebarNoticeBox.Title>
                <SidebarNoticeBox.Paragraph>
                  The following user was found with matching details to your search parameters.
                </SidebarNoticeBox.Paragraph>
              </SidebarNoticeBox>
            )}

            {hasResult && (
              <Form.Field direction="column" label="Matching User">
                <SidebarModal.User
                  onClick={() => editUser(editUserUrl)}
                  subtitle={agentEmail}
                  title={full_name}
                />
              </Form.Field>
            )}
          </Form>
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={searching}
          onClick={() => findAgent(entityState)}
          size="large"
        >
          Search Agent
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

FindAgentModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

FindAgentModal.defaultProps = {
  modalKey: 'FindAgentModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <FindAgentModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
